import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Moment from 'moment';
import Swal from 'sweetalert2';
let user = JSON.parse(localStorage.getItem('user_info'));


export default function ViewwithgstSale() {
    const login_id = user['id'];
    const [SaleData, setSaleData] = useState([]);
    const [searchvalue, setsearchvalue] = useState("");
    useEffect(async () => {
        getSaleData();
        if (searchvalue=='') {
            getSaleData();
        }
    }, [])
   
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::: GET ITEMS LIST CODE START ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

    async function getSaleData(){
        let result = await fetch(""+user.api+"api/get_withgstsale/" + login_id);
        result = await result.json();
        setSaleData(result);
    }
    // ::::::::::::::::::::::::::::::::::::::::::::::: GET SEARCH DATA :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

        async function getSearchData() {
            const form_data = new FormData();
            form_data.append('searchvalue', searchvalue);
            form_data.append('login_id', login_id);
            
            let result = await fetch(""+user.api+"api/purchase_search", { method: 'POST', body: form_data });
            result = await result.json();
            setSaleData(result);
    }

    async function delSale(id) {
        let result = await fetch(""+user.api+"api/delete_withgstsale/" + id, {
            method: 'DELETE'
        }, []);
        result = await result.json();
        if (result === 1) {
            Swal.fire('Success!', 'With Gst Sale Data Successfully Deleted!', 'success')
            getSaleData();
        } else {
            Swal.fire('Sorry!', 'Something was Wrong!', 'error')
        }
    }
    async function viewSale(id) {
        window.location.href = '/view-with-sale-item/'+ id +'';
    }

    // ================================================================================================================================================
    // ================================================================================================================================================

    return (
        <div>
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <br/>
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary float-6" >|| View With GST Sale ||</button>
                        <a className="btn btn-info btn-sm"  href='/with-gst-sale'>Add With GST Sale</a><br/><br/>
                        <div className="card card-primary card-outline ex1">
                        {/* <div className="row p-1">
                            &nbsp;&nbsp;<input onKeyUp={getSearchData} type="search"  value={searchvalue} onChange={(e) => setsearchvalue(e.target.value)} className='form-control col-sm-4' placeholder='Enter Purchase Details......'/>&nbsp;
                        </div> */}
                        <div className="card-body table-responsive p-0" >
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Customer Name</th>
                                            <th>Customer Mobile</th>
                                            <th>Sale Date</th>
                                            {/* <th>Total </th> */}
                                            {/* <th>Discount</th> */}
                                            <th>Total</th>
                                            <th>Paid </th>
                                            <th>Remaining</th>
                                            <th width="110">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            SaleData.map((item, num = 1) =>
                                                <tr key={num+1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.cust_name}</td>
                                                    <td>{item.mobile}</td>
                                                    <td>{Moment(item.sale_date).format('DD-MMM-YYYY')}</td>
                                                    {/* <td>{item.total_amount}</td> */}
                                                    {/* <td>{item.distotal1}</td> */}
                                                    <td>{item.grandtotal}</td>
                                                    <td>{item.paid}</td>
                                                    <td>{item.remaining}</td>
                                                    <td width="100">
                                                        <a  onClick={() => viewSale(item.id)}  className="btn btn-sm btn-success" > <i className="fa fa-eye"></i></a>
                                                       &nbsp;<a  onClick={() => delSale(item.id)}  className="btn btn-sm btn-danger" > <i className="fa fa-trash"></i></a>
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}
        </div>
    )
}
